// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2k8kW","buttons":"styles_buttons__3rY1w"};